import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="module-storage-formats" id="module-storage-formats"></a>
    <h1 {...{
      "id": "requireuxpstorageformats"
    }}>{`require('uxp').storage.formats`}</h1>
    <a name="new-module-storage-formats-new" id="new-module-storage-formats-new"></a>
    <h2 {...{
      "id": "formats"
    }}>{`formats()`}</h2>
    <p>{`This namespace describes the file content formats supported in FS methods like read and write.`}</p>
    <a name="module-storage-formats-utf8" id="module-storage-formats-utf8"></a>
    <h2 {...{
      "id": "utf8--symbol"
    }}>{`utf8 : `}<inlineCode parentName="h2">{`Symbol`}</inlineCode></h2>
    <p>{`UTF8 File encoding`}</p>
    <a name="module-storage-formats-binary" id="module-storage-formats-binary"></a>
    <h2 {...{
      "id": "binary--symbol"
    }}>{`binary : `}<inlineCode parentName="h2">{`Symbol`}</inlineCode></h2>
    <p>{`Binary file encoding`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      